export const errorMessageHandler = (
  error: any,
  defaultMessage = 'An error occurred'
) => {
  if (!error || error.detail === undefined || error.detail === null) {
    return defaultMessage
  }

  if (typeof error.detail === 'string') {
    return error.detail
  }

  if (Array.isArray(error.detail)) {
    try {
      const messages = error.detail
        .map((item: any) => {
          if (item && typeof item === 'object' && item.msg) {
            const location = item.loc ? ` at ${item.loc.join('.')}` : ''
            return `${item.msg}${location}`
          }
          return null
        })
        .filter(Boolean)

      if (messages.length > 0) {
        return messages.join('\n')
      }
    } catch (e) {
      console.error('Error parsing error details:', e)
    }
  }

  return defaultMessage
}
